<template lang="pug">
div
  slot(name="activator" :toggle="toggle")
    v-btn(small color='primary' 
      @click="toggle" 
      :disabled="disabledAccept"
      outlined data-test="c-accept"
    ) accept
  accept-dialog(
    v-model="showing" 
    :cbrUserDefault="model.accountUsername" 
    @okClicked="acceptHandler"
    :model="model"
  )
</template>
<script>
import { CBR_STATUS } from '../core/candidates-const'
import errorsMixin from '@/mixins/errors.mixin'

export default {
  mixins: [errorsMixin],
  props: {
    ID: {
      required: true
    },
    model: Object,
    disabled: Boolean
  },
  data: () => ({
    showing: false
  }),

  computed: {
    disabledAccept() {
      if(this.model.status === CBR_STATUS.RESERVED) return true
      return false
    },
  },

  inject: ['svc'],

  methods: { 
    toggle() {
      if(this.disabledAccept) return
      this.showing = !this.showing
    },

    Svc() {
      return this.svc()
    },

    acceptHandler(cbrUser) {
      this.toggle()
      this.accept(cbrUser)
    },

    async accept(payload) {
      try {
        let res = await this.Svc().accept([this.ID], payload)
        this.$notify({text: 'Started accepting', type: 'success'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    }
  },

  components: {
    acceptDialog: () => import('./CandidateAcceptModal.vue')
  }
}
</script>